import iACST_HERO from '../../assets/iACST_Hero_final.png'

export const banner_title = [
    {
        imagebanner: iACST_HERO,
    },
]
export const testcriteria = [
    {
        mainheading: 'Test details',
        content: [
            {
                headings: [
                    { mode: 'Mode of Examination', details: 'Online (Computer-Based Test)', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/online-icon1.svg' },
                    { mode: 'Exam Duration', details: '60 minutes', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/watch-icon3.svg' },
                    { mode: 'Availability', details: '9 AM to 10 PM - 7 days a week (Monday to Sunday)', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg' },
                    // { mode: 'Validity of iACST Scholarship(s)', details: '30 days', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg' },
                ]
            }
        ]
    },
    {
        mainheading: 'iACST Eligibility Criteria',
        content: [
            {
                headings: [
                    { mode: 'Class 5th passing students', details: 'Students who have completed Class 5 and are moving to Class 6 are eligible to sit for iACST.', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/eight-iocn-4.svg' },
                    {
                        mode: 'Class 6th to 12th students', details: 'Students studying in Classes 6 to 12 are eligible for iACST.', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/sevnth-icon5.svg'
                    },
                    { mode: 'Class 12th passed students', details: 'Students who have completed Class 12 (droppers/repeaters) are also eligible for iACST', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/eight-iocn-4.svg' },
                ]
            }
        ]
    }
];

export const scholarships = [
    {
        targetId: '1',
        heading: 'What is iACST?',
        subheading: 'iACST stands for Instant Admission Cum Scholarship Test. It is an online Scholarship Exam conducted by Aakash Institute. It provides students with a chance to get admission along with scholarships of up to 90% in NEET, JEE, and Foundation programs at Aakash Institute.',
        bulletpoints: [
        ],
    },
    {
        targetId: '2',
        heading: 'What is iACST eligibility?',
        subheading: 'The iacst eligibility criteria are based on your current class and desired test stream. Students from Class 6 to 12, including droppers for medical/engineering, are eligible to apply based on the prescribed iacst eligibility criteria.',
        bulletpoints: [
        ],
    },
    {
        targetId: '3',
        heading: 'How can I complete iACST registration?',
        subheading: '',
        bulletpoints: [
            {
                point: 'Start the registration process by visiting the official Aakash iACST scholarship test portal.',
            },
            {
                point: 'Enter your mobile number and verify it using the OTP sent to you.',
            },
            {
                point: 'Enter your academic details, such as class, subjects, and required information.',
            },
            {
                point: 'Select your preferred test date and time slot after planning your preparation.',
            },
        ],
    },
    {
        targetId: '4',
        heading: 'Can I appear for iACST more than once in the same academic year?',
        subheading: 'Yes, in most cases, Aakash allows students to appear for iACST more than once in the same academic year. It helps students to increase their scholarship percentage or change their course or centre. However, the latest score is mostly taken into consideration for admission and scholarship purposes.',
        bulletpoints: [
        ],
    },
    {
        targetId: '5',
        heading: 'Is there any fee for iACST?',
        subheading: 'iACST is completely free. You can register for iACST online and choose your preferred date and time slot for the exam.',
        bulletpoints: [
        ],
    },
    {
        targetId: '6',
        heading: 'What are the subjects I have to prepare for the iACST scholarship exam?',
        subheading: 'For the Aakash iACST exam, students of different classes have to prepare for different subjects. Students from Class 6 to 9 will be tested for subjects like Physics, Chemistry, Biology, and Maths. Students above Class 10 will be tested for subjects depending on whether they want to study engineering subjects or medical subjects.',
        bulletpoints: [
        ],
    },
    {
        targetId: '7',
        heading: 'What are the requirements to take the iACST online?',
        subheading: 'It is recommended to take the iACST on a desktop or laptop computer. You will require a stable internet connection and a browser to access the iACST test portal.',
        bulletpoints: [
        ],
    }
]